/*
 * pulse.js -- sdileny modul pulsu `.th-pulse` (task BD, majitel 7. 9.
 * doslova: "necháme tam jen to CTA co je vlevo a to bude trochu
 * pulsovat -- nastavíme nějaké konzistentní pulsování a motion na
 * všechny CTA, telefony, maily, ikonky telefonů atd. ... myslím že ne
 * pořád ale jednou za čas to 3x pulsne").
 *
 * CO MODUL DELA: kazdemu prvku s tridou `.th-pulse` (nebo `.th-pulse--glow`)
 * hlida vstup do viewportu -- pri prvnim vstupu pripoji `.is-pulsing`
 * (spusti CSS animaci `th-pulse-scale`/`th-pulse-glow` z components.css,
 * `--pulse-count` (3) opakovani), po jejim dobehnuti tridu odebere a
 * zalozi `setInterval` na `--pulse-period` (12s, ctenou z computed
 * style, fallback DEFAULT_PERIOD_MS), ktery trojpuls opakuje, DOKUD je
 * prvek stale ve viewportu. Kdyz prvek viewport opusti, interval se
 * zastavi (zadny puls na necem, co uzivatel nevidi).
 *
 * PROC PER-PRVEK INTERVAL, NE JEDEN SDILENY: kazdy prvek muze vstoupit
 * do viewportu v jinou chvili (scroll), takze spolecny casovac by
 * pulsoval vsechno najednou misto "kazdy svych 12s od sveho vstupu" --
 * presne to, co CSS `animation-delay` u `ctapulse`/`hintPulse` v navrhu
 * take resi per-prvek.
 *
 * PREFERS-REDUCED-MOTION (JS pojistka, POKYNY §5b): kdyz uzivatel
 * pohyb odmitl, modul se rovnou vrati -- ZADNY IntersectionObserver,
 * ZADNY setInterval, ZADNA trida `.is-pulsing` se nikdy neprida. CSS
 * ma vlastni nezavislou pojistku (`@media (prefers-reduced-motion:
 * reduce)` v components.css), takze i kdyby JS nekde selhal, animace
 * se nezobrazi.
 *
 * DEGRADACE BEZ `IntersectionObserver`: modul rovnou skonci (fail-open
 * -- prvek zustane staticky, zadna chyba v konzoli). Zadny nahradni
 * scroll listener, ktery by nikdo nezmeril (stejny principle jako
 * `stats.js`).
 *
 * ZADNA ZMENA ROZMERU: animace pracuje vyhradne s `transform: scale()`
 * (definovano v CSS), takze modul sam nepocita ani nezapisuje zadny
 * layout-ovlivnujici styl -- nulovy CLS.
 *
 * BD-3 (majitel 7. 9., doslova: "to pulsovani vsech CTA, mailu a
 * telefonu je uz moc vyrazne, trochu mene"): prvni puls po vstupu do
 * viewportu uz NENI okamzity -- `INITIAL_DELAY_MS` (1,5s) ho odloz,
 * aby motion nenaskocil hned pri prvnim renderu sekce. Dalsi opakovani
 * (perioda `--pulse-period`, ted 20s) uz zadny dalsi delay nemaji --
 * jen prvni puls po prichodu do viewportu.
 */

/** Volba uzivatele "omezit pohyb". */
const MOTION_QUERY = '(prefers-reduced-motion: reduce)';

import { guard } from './resize-guard.js';

/** Trida spoustejici animaci (CSS `components.css`, `.th-pulse.is-pulsing`). */
const PULSING_CLASS = 'is-pulsing';

/** Vychozi perioda mezi trojpulsy, kdyz token `--pulse-period` neni citelny (12s, POKYNY BD). */
const DEFAULT_PERIOD_MS = 12000;

/** Vychozi pocet pulsu v jednom "burstu", kdyz token `--pulse-count` neni citelny (2, BD-3). */
const DEFAULT_COUNT = 2;

/** Vychozi delka jednoho burstu, kdyz token `--pulse-dur`/`--pulse-count` neni citelny (1,7s x 2, BD-3). */
const DEFAULT_BURST_MS = 1700 * DEFAULT_COUNT;

/** Zpozdeni prvniho pulsu po vstupu do viewportu (BD-3, nalez majitele -- ne uz okamzite). */
const INITIAL_DELAY_MS = 1500;

/**
 * Selektor plovouciho/spodniho docku (`dock.js`, `nav#th-dock.mdock`).
 * Prvky uvnitr NIKDY nedostavaji IO pozorovatele (1.27.13, koordinatoruv
 * nalez): dock je `position: fixed`, takze jeho geometricky prusecik
 * s viewportem se prepocita pri KAZDE zmene vysky viewportu (iOS schova/
 * ukaze listu adresy po prvnim tapu po scrollu -- 635 -> 874 px), i kdyz
 * dock sam zadny novy stav nedostava. Prekroceni prahu 0.2 pri takovem
 * prepoctu spustilo `.is-pulsing` bez ohledu na `INITIAL_DELAY_MS`
 * (prvek uz mohl byt "vstoupivsi" driv, jen IO znovu dorucil zaznam) --
 * a WebKit v hover fazi prvniho tapu po scrollu vzal tu mutaci jako
 * zmenu obsahu a klik zahodil (majitel: "sjedu niz, vyjede CTA a 2
 * tapy"). Puls na docku ted rozhoduje vyhradne `dock.js` (`transitionend`/
 * `animationend`/rAF fallback po dokonceni prijezdu, jednou za stranku),
 * ne tenhle IO modul.
 */
const DOCK_SELECTOR = '.mdock';

/*
 * Ochranne okno po zmene velikosti viewportu drzi sdileny `resize-guard.js`
 * (1.27.13): porovnava `innerWidth`/`innerHeight` pri kazdem volani, takze
 * zachyti i zmenu, ke ktere IO zaznam dorazil DRIV nez udalost `resize`
 * (namereno na stagingu -- puls se objevoval v okne tapu i s lokalnim
 * `lastResizeAt`).
 */

/**
 * Precte cas z CSS custom property na prvku (napr. "1.7s", "12s") a
 * prevede na milisekundy. Fallback, kdyz token chybi nebo je necitelny.
 *
 * @param {Element} el       Prvek, ze ktereho se cte computed style.
 * @param {string}  varName  Jmeno custom property (vc. "--").
 * @param {number}  fallback Hodnota v ms, kdyz se nepodari precist.
 * @return {number} Cas v milisekundach.
 */
function readMs(el, varName, fallback) {
	try {
		const raw = window.getComputedStyle(el).getPropertyValue(varName).trim();

		if (!raw) {
			return fallback;
		}

		const value = parseFloat(raw);

		if (!isFinite(value) || value <= 0) {
			return fallback;
		}

		return raw.indexOf('ms') !== -1 ? value : value * 1000;
	} catch {
		return fallback;
	}
}

/**
 * Precte celociselnou CSS custom property (napr. "--pulse-count: 2") na
 * prvku. Fallback, kdyz token chybi nebo je necitelny.
 *
 * @param {Element} el       Prvek, ze ktereho se cte computed style.
 * @param {string}  varName  Jmeno custom property (vc. "--").
 * @param {number}  fallback Hodnota, kdyz se nepodari precist.
 * @return {number} Pocet opakovani.
 */
function readCount(el, varName, fallback) {
	try {
		const raw = window.getComputedStyle(el).getPropertyValue(varName).trim();
		const value = parseInt(raw, 10);

		return isFinite(value) && value > 0 ? value : fallback;
	} catch {
		return fallback;
	}
}

/**
 * Provede `fn` az KDYZ uz nejsme v ochrannem okne po resize -- pokud
 * prave jsme, `fn` se odlozi na konec okna (a pri opakovanem volani
 * znovu preveri, kdyby mezitim prisel DALSI resize -- okno se tak
 * postupne posouva, dokud se viewport neustali).
 *
 * OPRAVA 1.27.13 (koordinatoruv nalez na stagingu i po puvodni
 * IO-urovnove ochrane nize): `.hintbox.th-pulse--glow` (animationstart)
 * a `a.htel`/`a.btn` (zmena tridy) se porad objevovaly uvnitr 0-400 ms
 * okna tapu po navratu listy. Duvod: puvodni ochrana kontrolovala jen
 * OKAMZIK, kdy `IntersectionObserver` dorucil zaznam -- ale samotna
 * mutace (`classList.add`/`remove`) muze prijit AZ PRES `setInterval`/
 * `setTimeout` o stovky ms az sekundy pozdeji (`INITIAL_DELAY_MS`,
 * `burstMs`, `periodMs`), tedy uplne mimo cas, kdy IO cokoli kontrolovalo.
 * `IntersectionObserver` navic neni casove svazany s udalosti `resize`
 * (dve nezavisle asynchronni fronty) -- fixni okno namerene od okamziku
 * DORUCENI IO zaznamu tak nemuselo krýt skutecny okamzik mutace vubec.
 * Mutace primo v miste, kde se DEJE (`burst()`), je jedina zaruka, ktera
 * na tomhle casovani nezavisi -- chrani VSECHNY cesty (cerstvy start,
 * periodicke opakovani, konec burstu) najednou, bez ohledu na to, CO
 * mutaci vyvolalo.
 *
 * @param {function(): void} fn Mutace k provedeni (classList.add/remove).
 * @return {void}
 */
function guardedMutate(fn) {
	guard(fn);
}

/**
 * Spusti jeden trojpuls na prvku a po jeho dobehnuti tridu odebere
 * (aby se dala pripojit znovu pri dalsim opakovani -- opakovane
 * pripojeni STEJNE tridy by druhou animaci nespustilo). Obe mutace
 * (pridani i odebrani `PULSING_CLASS`) jdou pres `guardedMutate()`.
 *
 * @param {Element} el       Pulsujici prvek.
 * @param {number}  burstMs  Delka celeho trojpulsu v ms.
 * @return {void}
 */
function burst(el, burstMs) {
	guardedMutate(function () {
		el.classList.add(PULSING_CLASS);


		window.setTimeout(function () {
			guardedMutate(function () {
				el.classList.remove(PULSING_CLASS);
			});
		}, burstMs);
	});
}

/**
 * Zaridi periodicke opakovani trojpulsu pro jeden prvek, dokud je ve
 * viewportu; zastavi se, kdyz prvek viewport opusti.
 *
 * @param {Element} el Prvek s tridou `.th-pulse`/`.th-pulse--glow`.
 * @return {void}
 */
function watch(el) {
	const durMs = readMs(el, '--pulse-dur', DEFAULT_BURST_MS / DEFAULT_COUNT);
	const countN = readCount(el, '--pulse-count', DEFAULT_COUNT);
	const burstMs = durMs * countN;
	const periodMs = readMs(el, '--pulse-period', DEFAULT_PERIOD_MS);

	let timer = null;
	let delayTimer = null;

	function start() {
		if (timer !== null || delayTimer !== null) {
			return;
		}

		/*
		 * BD-3: PRVNI puls po vstupu prijde az po INITIAL_DELAY_MS, ne
		 * okamzite -- dalsi opakovani (setInterval) uz zadny extra delay
		 * nemaji, jen samotnou periodu.
		 */
		delayTimer = window.setTimeout(function () {
			delayTimer = null;
			burst(el, burstMs);
			timer = window.setInterval(function () {
				burst(el, burstMs);
			}, periodMs);
		}, INITIAL_DELAY_MS);
	}

	function stop() {
		if (delayTimer !== null) {
			window.clearTimeout(delayTimer);
			delayTimer = null;
		}

		if (timer !== null) {
			window.clearInterval(timer);
			timer = null;
		}
	}

	if (!('IntersectionObserver' in window)) {
		// Fail-open (jako stats.js): bez pozorovatele prvek zustane staticky.
		return;
	}

	/*
	 * PULS JEN JEDNOU ZA ZIVOT PRVKU (1.27.13, koordinatoruv nalez -- viz
	 * DOCK_SELECTOR docblok): `io.unobserve(el)` hned pri prvnim
	 * `isIntersecting` -- prvek uz nikdy nedostane DALSI zaznam, takze ho
	 * zadny pozdejsi resize nemuze znovu "aktivovat".
	 *
	 * PUVODNE tu byla JESTE druha vrstva -- zahazovani CELEHO zaznamu (vc.
	 * `unobserve`) do 300 ms po `resize`. Ukazalo se to jako DERAVE:
	 * IntersectionObserver neni casove svazany s udalosti `resize` (dve
	 * nezavisle asynchronni fronty), takze fixni okno namerene od
	 * DORUCENI IO zaznamu nekdy minulo skutecny problem -- a `unobserve`
	 * se pri zahozeni zaznamu NEVOLAL, takze prvek mohl zustat trvale
	 * "zamrzly" (dalsi zaznam uz nikdy neprijde, pokud zustane pořád
	 * intersecting). Zaznam se ted zpracovava VZDY normalne (`unobserve`
	 * + `start()` spolehlive probehnou) -- skutecnou ochranu proti mutaci
	 * uvnitr 300 ms po resize ted resi VYHRADNE `guardedMutate()` primo v
	 * `burst()`, viz jeho docblok.
	 */
	const io = new IntersectionObserver(function (entries) {
		entries.forEach(function (entry) {
			if (entry.isIntersecting) {
				io.unobserve(entry.target);
				start();
			} else {
				stop();
			}
		});
	}, { threshold: 0.2 });

	io.observe(el);
}

/**
 * Inicializace modulu pulsu. Vola se z `index.js` uvnitr vlastniho
 * try/catch (kazdy modul samostatne, pad jednoho nesmi shodit ostatni).
 *
 * @return {void}
 */
export function init() {
	if (window.matchMedia && window.matchMedia(MOTION_QUERY).matches) {
		// Uzivatel odmitl pohyb -- zadny pozorovatel, zadny timer, zadna trida.
		return;
	}

	const els = Array.prototype.slice.call(document.querySelectorAll('.th-pulse, .th-pulse--glow'));

	// DOCK MIMO IO UPLNE (viz DOCK_SELECTOR docblok vys) -- `dock.js` si
	// puls na svych `.mdock-tel`/`.mdock-cta` resi sam, po dokonceni
	// prijezdu docku, ne pres tenhle pozorovatel.
	els.filter(function (el) {
		return !el.closest(DOCK_SELECTOR);
	}).forEach(watch);
}
